import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class ProjectExpenseAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'ProjectExpenses';
}

export default new ProjectExpenseAPI();
